import axios from "axios";
import { errorToast } from "../../../../react-toastfiy/toast";

class TAService {
  GetUserList = (formData) => {
    for (let [key, value] of formData.entries()) {
    }
    return axios({
      method: "post",
      url: `users/get-all-users-name-phone`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };
  RequestAdminApproval = (formData) => {
    return axios({
      method: "post",
      url: `users/taonboarding-request-for-admin-approval`,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };
  GetTAOnboardingApprovalList = (status = "pending") => {
    return axios({
      method: "get",
      url: `users/get-taonboarding-admin-approval-list?status=${status}`,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };
  ApproveTAOnboarding = (formData) => {
    return axios({
      method: "post",
      url: `users/taonboarding-admin-approval`,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };
  CreateTAUser = (formData) => {
    return axios({
      method: "post",
      url: `users/create-ta-case`,
      data: JSON.stringify(formData),
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };
  UpdateTAUser = (formData) => {
    return axios({
      method: "post",
      url: `users/update-ta-case`,
      data: JSON.stringify(formData),
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };
  UpdateLOSApplicationId = (formData) => {
    return axios({
      method: "post",
      url: `users/update-ta-case-los-application-id`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };
  // GetLimitSettingPendingCompleted = (formData) => {
  //   return axios({
  //     method: "post",
  //     url: `users/get_all-ta-cases-limit-setting-pending-completed`,
  //     data: formData,
  //   })
  //     .then((response) => {
  //       return response.data;
  //     })
  //     .catch(function (error) {
  //       errorToast(error?.msg);
  //       console.log(error);
  //     });
  // };

  GetAllTAUser = (formData) => {
    for (let [key, value] of formData.entries()) {
    }
    return axios({
      method: "post",
      url: `users/get-all-ta-cases-sh`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };
  GetAllTAUserByBA = (formData) => {
    for (let [key, value] of formData.entries()) {
    }
    return axios({
      method: "post",
      url: `users/get-all-ta-cases-ba`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };

  GetAllTAUserByRisk = (formData) => {
    for (let [key, value] of formData.entries()) {
    }
    return axios({
      method: "post",
      url: `users/get-ta-cases-by-limit-setting-mail-status`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };
  ConformMailsend = (formData) => {
    for (let [key, value] of formData.entries()) {
    }
    return axios({
      method: "post",
      url: `users/send-ta-limit-setting-request-mail-to-tf`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };

  GetAllTAUserBySA = (formData) => {
    for (let [key, value] of formData.entries()) {
    }
    return axios({
      method: "post",
      url: `users/get-all-ta-cases-limit-setting-pending-completed`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };

  UpdateLimitSetting = (body) => {
    return axios({
      method: "post",
      url: `users/update-ta-case-limit-setting-after-confirmation-mail`,
      data: body,
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };

  AddComment = (formData) => {
    for (let [key, value] of formData.entries()) {
    }
    return axios({
      method: "post",
      url: `users/add-ta-case-note`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };
  GetComment = (formData) => {
    for (let [key, value] of formData.entries()) {
    }
    return axios({
      method: "post",
      url: `users/get-ta-case-notes`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };

  UploadDoc = (formData) => {
    for (let [key, value] of formData.entries()) {
    }
    return axios({
      method: "post",
      url: `users/upload-ta-case-documents`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };
  // Stamp paper / merged document for the limit setting e-sign
  // (formData: taOnboardingCaseId, docType = stamp_paper | merged_document, file).
  UploadLimitSettingEsignDoc = (formData) => {
    return axios({
      method: "post",
      url: `users/upload-ta-limit-setting-esign-doc`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };
  // Send the merged limit setting PDF for e-sign (formData: taOnboardingCaseId,
  // buyerAadharName, docPages JSON, file).
  SendLimitSettingEsign = (formData) => {
    return axios({
      method: "post",
      url: `users/send-ta-limit-setting-esign`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };
  UploadDocSignzy = (formData) => {
    for (let [key, value] of formData.entries()) {
    }
    return axios({
      method: "post",
      url: `users/send-ta-document-to-signzy`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };
  VerifyOrRejectDocumentsByBA = (formData) => {
    for (let [key, value] of formData.entries()) {
    }
    return axios({
      method: "post",
      url: `users/approve-reject-ta-case-document`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };
  VerifyOrRejectBusDetailsByBA = (formData) => {
    for (let [key, value] of formData.entries()) {
    }
    return axios({
      method: "post",
      url: `users/approve-reject-ta-case-business-details`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };
  VerifyCaseByBA = (formData) => {
    for (let [key, value] of formData.entries()) {
    }
    return axios({
      method: "post",
      url: `users/approve-ta-case-by-ba`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };
  GetTACaseDetails = (formData) => {
    for (let [key, value] of formData.entries()) {
    }
    return axios({
      method: "post",
      url: `users/get-ta-case-details`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };

  AadharConcentbase64 = (formData) => {
    for (let [key, value] of formData.entries()) {
    }
    return axios({
      method: "post",
      url: ``,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };

  LimitSettingOfflineDoc = (formData) => {
    return axios({
      method: "post",
      url: `users/ta-limit-setting-all-docs-uploaded-confirmation`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };
  GetLimitSettingData = (formData) => {
    return axios({
      method: "post",
      url: `users/get-ta-case-documents`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };
  GlobalUpdateTaCaseField = (formData) => {
    return axios({
      method: "post",
      url: `users/global-update-ta-case-fields`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };
  DeletePartnerById = (formData) => {
    return axios({
      method: "post",
      url: `users/delete-ta-case-partner-details`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  }; 
   DeleteTACase = (formData) => {
    return axios({
      method: "post",
      url: `users/delete-ta-case`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };

  // Upload partner document (Aadhar front, Aadhar back, PAN)
  UploadPartnerDoc = (formData) => {
    for (let [key, value] of formData.entries()) {
    }
    return axios({
      method: "post",
      url: `users/upload-ta-partner-documents`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };

  // Approve or reject partner document
  ApproveRejectPartnerDoc = (formData) => {
    for (let [key, value] of formData.entries()) {
    }
    return axios({
      method: "post",
      url: `users/approve-reject-ta-partner-document`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };

  // Generate Reference Number for MT Sanction Letter
  GenerateReferenceNumber = (formData) => {
    return axios({
      method: "post",
      url: `users/generate-ta-reference-number`,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };

  // Renewal cycles and their audit entries for one case, for the detail screen.
  GetCaseRenewals = (taOnboardingCaseId) => {
    return axios({
      method: "get",
      url: `users/api/ta-onboarding/case/${taOnboardingCaseId}/renewals`,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };
}
export default new TAService();
